import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { finalize, Observable } from "rxjs";
import { TokenService } from '../services/token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isLoggingOut = false;

  constructor(private tokenService: TokenService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = localStorage.getItem('appLanguage') || 'es';
    const token = this.tokenService.getToken();
    const tokenExpiration = this.tokenService.getTokenExpiration();

    let clonedRequest = request;

    if (!request.url.includes('/login')) { // Evita modificar las solicitudes de login
      if (token && tokenExpiration && Date.now() < tokenExpiration) { // Verifica si el token sigue válido
        clonedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else if (token && !this.isLoggingOut) {
        this.isLoggingOut = true; // Marca que se está cerrando sesión
        this.tokenService.logout(true);
      }
    }

    // Agregar encabezado de idioma en todas las peticiones
    clonedRequest = clonedRequest.clone({
      setHeaders: {
        'Accept-Language': language,
      },
    });

    return next.handle(clonedRequest).pipe(
      finalize(() => {  // Se ejecuta al finalizar la petición
        this.isLoggingOut = false;
      })
    );
  }
}
